import { AlertCircle, Coins, CreditCard } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTokens } from '../../hooks';
import { Button, Modal } from './';

interface InsufficientTokensModalProps {
  isOpen: boolean;
  onClose: () => void;
  tokensBalance: number;
}

export const InsufficientTokensModal: React.FC<InsufficientTokensModalProps> = ({
  isOpen,
  onClose,
  tokensBalance,
}) => {
  const { t } = useTranslation();
  const { openBuyTokensModal } = useTokens();

  const handleOpenPlans = () => {
    onClose();
    openBuyTokensModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('subscription.insufficientAccessTitle')}
      size="md"
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <AlertCircle className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
          </div>
          <div className="flex-1">
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              {t('subscription.insufficientAccessDescription')}
            </p>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 flex items-center space-x-3">
              <Coins className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              <div>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {t('tokens.currentBalance')}
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white">
                  {tokensBalance} {t('tokens.tokens')}
                </p>
              </div>
            </div>
            {tokensBalance === 0 && (
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
                {t('subscription.noActivePlanHint')}
              </p>
            )}
          </div>
        </div>

        <div className="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700">
          <Button
            variant="primary"
            onClick={handleOpenPlans}
            className="flex items-center"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            {t('subscription.choosePlan')}
          </Button>
          <Button variant="outline" onClick={onClose}>
            {t('common.close')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
